module.exports = __webpack_public_path__ + "img/caution.330348d2.svg";